import { mapperModuleMedia, mapperModuleUsp } from '../../../core/data-layer/modules/mappers'
import {
  mapperBlockCallToAction,
  mapperBlockFaqGroup,
  mapperBlockHighlight
} from '../../../core/data-layer/blocks/mappers'
import type { MapperImageOptions, MapperOptions } from '#layers/core/types'
import imageSizes from '../../../core/constants/imageSizes'

/**
 * Page content payment methods overview mapper
 * normalizes data to be used in pages
 *
 */
export default (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }
  const regionImageOptions: MapperImageOptions = { resize: true, sizes: imageSizes.columns3_11, lazy: true }
  const regionCountryImageOptions: MapperImageOptions = {
    resize: true,
    sizes: imageSizes.payment_methods_country_card,
    lazy: true
  }

  return {
    subtitle: data.subtitle || '',
    buttonText: data.paymentMethodsButtonText || '',
    paymentMethods: data?.paymentMethodsCollection?.items?.map((i) => i.sys.id) || [],
    usps: data?.uspsCollection?.items?.map((item) => mapperModuleUsp(item)).filter(Boolean) || [],
    highlight: mapperBlockHighlight(data.highlight, options),
    faq: mapperBlockFaqGroup(data.faq),
    callToAction: mapperBlockCallToAction(data.callToAction, options.getUrl),
    regionsGalleryTitle: data.regionsGalleryTitle || '',
    regionsGalleryText: data.regionsGalleryText || '',
    regionsGalleryItems:
      data.regions?.items.map((item) => ({
        name: item.region?.name || '',
        regionId: item.region?.sys?.id || '',
        url: options.getInternalUrl(item.sys?.id),
        image: mapperModuleMedia(item?.image, regionImageOptions)
      })) || [],
    paymentMethodCountryData:
      data.paymentMethodsGuidesRegionCountryData?.map((item) => ({
        ...item,
        image: mapperModuleMedia(item.image, regionCountryImageOptions)
      })) || []
  }
}
